import { useState } from "react";

import { format, parse, set } from "date-fns";

const validateDateRange = (date) => {
  return date?.getFullYear() < 1000 ? null : date;
};

const toDate = (dateString, formatString, alternateFormat) => {
  const parseDate = (ds, fs, withTime = false) => {
    const d = parse(ds, fs, new Date());

    if (Number.isNaN(d.getTime())) return null;

    return validateDateRange(withTime ? set(d, { hours: 12, minutes: 0 }) : d);
  };

  return (
    parseDate(dateString, formatString) ||
    parseDate(dateString, alternateFormat, true)
  );
};

const toString = (date, formatString) => {
  return validateDateRange(date) instanceof Date
    ? format(date, formatString)
    : "None";
};

export function useDateInput(
  initialDate,
  onDateChange = () => {},
  formatString = "MM/dd/yyyy, h:mm a",
  alternateFormat = "MM/dd/yyyy"
) {
  const [date, setDate] = useState(validateDateRange(initialDate));
  const [dateString, setDateString] = useState(
    toString(initialDate, formatString)
  );

  return {
    date: date,
    dateString: dateString,
    updateDateString: (ds) => {
      setDateString(ds);

      const updatedDate = toDate(ds, formatString, alternateFormat);
      setDate(updatedDate);
      onDateChange(updatedDate);
    },
    updateDate: (d) => {
      setDateString(toString(d, formatString));

      const updatedDate = validateDateRange(d);
      setDate(updatedDate);
      onDateChange(updatedDate);
    },
  };
}

export default useDateInput;
